import React from "react";
import { Breadcrumb } from "react-bootstrap";
import AdminUsersComp from "../../components/Admin/AdminUsers";

export default function AdminUsers() {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h3 className="mb-0">مدیریت کاربران</h3>

        <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
          <Breadcrumb.Item href="/admin/dashboard">
            <div className="d-flex align-items-center text-decoration-none">
              <i className="ri-home-4-line fs-18 text-primary me-1"></i>
              <span className="text-secondary fw-medium hover">داشبورد مدیریت</span>
            </div>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
            <span className="fw-medium">مدیریت کاربران</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <AdminUsersComp />
    </>
  );
}
